import {SkillsI18n} from '@/locales/base.message.locales';

export const skills: SkillsI18n = {
  titles: {
    skills: 'Skills',
    my_skills: 'My Skills',
    subtitle: 'Select your skills from the bottom',
  },
};

